import { StyleSheet } from '@react-pdf/renderer';

/**
 * Electrical Installation Certificate - PDF StyleSheet
 * BS 7671 IET wiring regulations official styling
 * Electrical sector palette: navy blue / white
 */

export const ELECTRICAL_COLORS = {
  navy: '#0B2545',
  blue: '#1D4E89',
  lightBlue: '#4A90D9',
  darkGray: '#333333',
  midGray: '#666666',
  lightGray: '#CCCCCC',
  paleGray: '#F0F0F0',
  white: '#FFFFFF',
  green: '#008855',
  red: '#CC0000',
  amber: '#FFCC00'
};

export const PDFStyles = StyleSheet.create({
  // Page
  page: {
    fontFamily: 'Helvetica',
    fontSize: 8,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 28,
  },

  // Global footer
  footer: {
    position: 'absolute',
    flexDirection: 'row',
    fontSize: 7,
    color: '#666666',
    left: 0,
    right: 0,
    bottom: 0,
    padding: 8,
    textAlign: 'center'
  },

  // Header
  headerPanel: {
    flexDirection: 'column',
    marginBottom: 8,
    backgroundColor: '#F0F0F0',
    padding: 8
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#0B2545'
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'center',
    color: '#404040',
    marginBottom: 4
  },
  standard: {
    fontSize: 8,
    textAlign: 'center',
    color: '#666666',
    marginTop: 4
  },

  // Section
  section: {
    marginBottom: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#1D4E89',
    wrap: false
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#FFFFFF',
    backgroundColor: '#1D4E89',
    padding: 4,
    marginBottom: 2
  },
  sectionTitleLight: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#0B2545',
    backgroundColor: '#E8EDF5',
    padding: 4,
    marginBottom: 2
  },

  // Fields
  fieldRow: {
    flexDirection: 'row',
    marginBottom: 3
  },
  fieldLabel: {
    fontSize: 8,
    fontWeight: 'bold',
    width: '30%',
    paddingRight: 2,
    color: '#404040'
  },
  fieldValue: {
    fontSize: 8,
    width: '70%',
    paddingLeft: 2
  },

  // Table styles
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000000'
  },
  tableRow: {
    flexDirection: 'row',
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: '#000000'
  },
  tableHeader: {
    backgroundColor: '#1D4E89',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  tableCell: {
    margin: 2,
    padding: 3,
    fontSize: 6
  },

  // Assessment
  assessment: {
    marginTop: 10,
    padding: 12,
    borderWidth: 2,
    borderStyle: 'solid'
  },
  assessmentTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center'
  },

  // Declaration
  declaration: {
    marginTop: 10,
    padding: 10,
    fontSize: 8,
    lineHeight: 1.4,
    textAlign: 'justify'
  },

  // Signatures
  signatureRow: {
    flexDirection: 'row',
    marginTop: 15,
    justifyContent: 'space-between'
  },
  signatureBox: {
    width: '45%',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid',
    paddingBottom: 6,
    textAlign: 'center',
    fontSize: 8
  },

  // Risk rating
  riskBanner: {
    marginTop: 8,
    padding: 6,
    backgroundColor: '#E8EDF5',
    textAlign: 'center',
    fontSize: 8
  }
});

export default PDFStyles;